export default "__VITE_ASSET__DR5fMqrp__"